function distToSegmentSquared(p, v, w) {
    const l2 = v.distanceToSquared(w);

    if (l2 <= 0) return { projected: v, distance: p.distanceToSquared(v) };

    const t = Math.max(0, Math.min(1, ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2));
    const projected = new THREE.Vector2(v.x + t * (w.x - v.x), v.y + t * (w.y - v.y));

    return { distance: projected.distanceToSquared(p), projected };
}

export default distToSegmentSquared;
export { distToSegmentSquared };